import { Put } from "#src/HttpClient.ts";
import { type Pinia } from "pinia";

const controller = "/strife/v1/illustrations";

export function getIllustration(pinia: Pinia, id: string | number) {
  return Put(pinia, {
    url: `${controller}/${id}`,
    includeEappData: true,
  });
}
